import * as IoC from 'typescript-ioc';
import { AppPrivateConfigurationDTO, AppPublicConfigurationDTO, IAppConfigurationDAO } from '../app-configuration.dao';
import { IApiClient } from '../../infrastructure/api-client';
import { ApiClient } from '../../infrastructure/implementations/api-client';
import { IRuntimeConfiguration } from '../../infrastructure/runtime-configuration';

export class AppConfigurationDAO extends IAppConfigurationDAO {
    public async getPublicConfiguration(): Promise<AppPublicConfigurationDTO> {
        const response = await this.publicApiClient.get<AppPublicConfigurationDTO>(this.publicConfigUrl);
        return response.parsedResponse;
    }
    public async getPrivateConfiguration(): Promise<AppPrivateConfigurationDTO> {
        const response = await this.apiClient.get<AppPrivateConfigurationDTO>(this.privateConfigUrl);
        return response.parsedResponse;
    }

    constructor(
        @IoC.Inject private readonly apiClient: IApiClient,
        @IoC.Inject private readonly configuration: IRuntimeConfiguration
    ) {
        super();
        this.publicApiClient = new ApiClient(this.configuration);
    }

    private readonly publicApiClient: IApiClient;

    private readonly publicConfigUrl = 'public/configuration/properties';
    private readonly privateConfigUrl = 'configuration/properties';
}
